import CustomerReportFilters from './CustomerReportFilter';

export default CustomerReportFilters;
